import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
  Box,
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  MenuItem,
  Switch,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip
} from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getExchangeReasonForDynamic, addNewExchangeReasonForDynamic, updateNewExchangeReasonForDynamic, updateExchangeReasonSurveyControl } from 'src/store/slices/dynamicCatalogSlice';
import AlertAndLoading from 'src/components/AlertAndLoading';
import {
  DARK,
  ORANGE,
  darkButtonSx,
  dialogPaperProps,
  inputSx,
  lightButtonSx,
  listboxProps,
  useDynamicStyles
} from 'src/components/dynamicCatalogStyles';
import DynamicListToolbar from 'src/components/DynamicListToolbar';
import DynamicGroupList, { isTruthyFlag } from 'src/components/DynamicGroupList';

const switchSx = {
  '& .MuiSwitch-switchBase.Mui-checked': { color: ORANGE },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: ORANGE }
};

const ExchangeTypesDynamic = () => {
  const classes = useDynamicStyles();
  const dispatch = useDispatch();
  const [exchangeReason, setExchangeReason] = React.useState([]);
  const [openKeys, setOpenKeys] = React.useState(new Set());
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  // Ekle / Güncelle popup (tek popup)
  const [editPopUp, setEditPopUp] = React.useState(false);
  const [editId, setEditId] = React.useState(0);
  const [editTop, setEditTop] = React.useState('');
  const [editDetail, setEditDetail] = React.useState('');
  const [editActive, setEditActive] = React.useState(1);
  // İade ikna anketi onayı
  const [surveyTarget, setSurveyTarget] = React.useState(null);
  const [searchText, setSearchText] = React.useState('');
  const [responseMessage, setresponseMessage] = React.useState('');
  const [uyari, setUyari] = React.useState(false);
  const [alertType, setAlertType] = React.useState({ ErrorType: 'error', ErrorTitle: 'Uyarı' });

  const isUpdate = !!editId;

  const getNewExchangeReason = () => {
    setLoading(true);
    return dispatch(getExchangeReasonForDynamic())
      .then(response => {
        setLoading(false);
        if (Array.isArray(response.payload)) setExchangeReason(response.payload);
      }).catch(() => { setLoading(false); });
  };

  useEffect(() => {
    getNewExchangeReason();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({ ErrorType: ErrorType, ErrorTitle: ErrorTitle });
    setUyari(true);
  }

  const toggleGroup = (key) => {
    setOpenKeys((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
  };

  const allOpen = exchangeReason.length > 0 && exchangeReason.every((g) => openKeys.has(g.Id));

  // Yeni değişim nedeni; gruptaki + ile açılırsa üst neden seçili gelir
  const openAdd = (group) => {
    setEditId(0);
    setEditTop(group?.Id ?? '');
    setEditDetail('');
    setEditActive(1);
    setEditPopUp(true);
  };

  const openUpdate = (detail, group) => {
    setEditId(detail.DEGISIM_NEDENI);
    setEditTop(group.Id);
    setEditDetail(detail.ACIKLAMA);
    setEditActive(isTruthyFlag(detail.Aktif) ? 1 : 0);
    setEditPopUp(true);
  };

  const closeEdit = () => {
    if (saving) return;
    setEditPopUp(false);
  };

  const handleSave = () => {
    if (!editDetail?.trim() || editTop === '') return;
    setSaving(true);
    const request = isUpdate
      ? dispatch(updateNewExchangeReasonForDynamic({
        ExchangeReasonTop: editTop,
        ExchangeReasonDesc: editDetail,
        Active: editActive,
        ExchangeReasonId: editId
      }))
      : dispatch(addNewExchangeReasonForDynamic({
        ExchangeReasonTop: editTop,
        ExchangeReasonDesc: editDetail,
        Active: editActive
      }));
    request.then(response => {
      setSaving(false);
      // eslint-disable-next-line eqeqeq
      if (response.payload?.ErrorCode == 0) {
        setEditPopUp(false);
        setOpenKeys((prev) => new Set(prev).add(editTop));
        getNewExchangeReason();
      } else {
        InfoAlert(response.payload?.ErrorDescription || 'İşlem sırasında hata oluştu.', 'error', 'Hata');
      }
    }).catch(() => { setSaving(false); });
  };

  const confirmSurveyChange = () => {
    if (!surveyTarget) return;
    const data = {
      Id: surveyTarget.id,
      SurveyCheck: surveyTarget.checked
    }
    setSaving(true);
    dispatch(updateExchangeReasonSurveyControl(data)).then(() => {
      setSaving(false);
      setSurveyTarget(null);
      getNewExchangeReason();
    })
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') return;
    setUyari(false);
  };

  const detailCount = exchangeReason.reduce((sum, g) => sum + (g.Detail?.length || 0), 0);

  return (
    <>
      <AlertAndLoading Message={responseMessage} open={uyari} AlertType={alertType} onClose={uyariKapat} />
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title="Değişim Nedenleri ve Detayları"
          subheader={loading ? 'Yükleniyor…' : `${exchangeReason.length} üst neden · ${detailCount} değişim nedeni`}
          action={
            <Button startIcon={<AddIcon />} sx={darkButtonSx} onClick={() => openAdd(null)}>
              Yeni Değişim Nedeni
            </Button>
          }
        />
        {loading && <LinearProgress sx={{ height: 2, '& .MuiLinearProgress-bar': { backgroundColor: ORANGE }, backgroundColor: '#ffe0b2' }} />}
        <DynamicListToolbar searchText={searchText} onSearchChange={setSearchText} placeholder="Üst neden veya değişim nedeni ara">
          <Button
            size="small"
            sx={{ ...lightButtonSx, ml: 'auto' }}
            startIcon={allOpen ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
            onClick={() => setOpenKeys(allOpen ? new Set() : new Set(exchangeReason.map((g) => g.Id)))}
          >
            {allOpen ? 'Tümünü Kapat' : 'Tümünü Aç'}
          </Button>
        </DynamicListToolbar>
        <Box sx={{ maxHeight: 600, overflowY: 'auto' }}>
          <DynamicGroupList
            groups={exchangeReason}
            openKeys={openKeys}
            onToggle={toggleGroup}
            searchText={searchText}
            getGroupKey={(g) => g.Id}
            getGroupLabel={(g) => g.Dsc}
            isGroupActive={(g) => isTruthyFlag(g.Active)}
            getDetails={(g) => g.Detail}
            getDetailKey={(d) => d.DEGISIM_NEDENI}
            getDetailLabel={(d) => d.ACIKLAMA}
            isDetailActive={(d) => isTruthyFlag(d.Aktif)}
            onAddInGroup={openAdd}
            addInGroupTooltip="Bu üst nedene değişim nedeni ekle"
            emptyText={loading ? '' : 'Kayıtlı değişim nedeni bulunamadı.'}
            renderDetailActions={(d, g) => (
              <>
                <Tooltip title={d.ANKET_KONTROL === true ? 'İade ikna anketi aktif' : 'İade ikna anketi pasif'}>
                  <Box
                    sx={{ display: 'flex', alignItems: 'center', fontSize: '11px', color: d.ANKET_KONTROL === true ? DARK : '#90a4ae', whiteSpace: 'nowrap' }}
                  >
                    <Switch
                      size="small"
                      sx={switchSx}
                      checked={d.ANKET_KONTROL === true}
                      onChange={(e) => setSurveyTarget({ id: d.DEGISIM_NEDENI, checked: e.target.checked, label: d.ACIKLAMA })}
                    />
                    İkna Anketi
                  </Box>
                </Tooltip>
                <Tooltip title="Düzenle">
                  <IconButton size="small" onClick={() => openUpdate(d, g)}>
                    <EditIcon sx={{ fontSize: 18, color: ORANGE }} />
                  </IconButton>
                </Tooltip>
              </>
            )}
          />
        </Box>
      </Card>

      {/* Ekle / Güncelle */}
      <Dialog open={editPopUp} onClose={closeEdit} fullWidth maxWidth="sm" PaperProps={dialogPaperProps}>
        <DialogTitle className={classes.dialogTitle}>
          {isUpdate ? 'Değişim Nedeni Düzenle' : 'Yeni Değişim Nedeni'}
          <IconButton size="small" onClick={closeEdit} disabled={saving}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '16px !important', opacity: saving ? 0.6 : 1, pointerEvents: saving ? 'none' : 'auto', transition: 'opacity 0.2s' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              size="small"
              fullWidth
              select
              label="Üst Değişim Nedeni"
              sx={inputSx}
              value={editTop}
              onChange={(e) => setEditTop(e.target.value)}
              SelectProps={{ MenuProps: { PaperProps: listboxProps } }}
            >
              {exchangeReason?.filter((g) => isTruthyFlag(g.Active) || g.Id === editTop).map((g) => (
                <MenuItem key={g.Id} value={g.Id} sx={{ fontSize: '13px' }}>
                  {g.Dsc}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              label="Değişim Nedeni"
              size="small"
              fullWidth
              sx={inputSx}
              value={editDetail}
              onChange={(e) => setEditDetail(e.target.value)}
            />
            <Box className={classes.dialogSection}>
              <div className={classes.sectionLabel}>Durum</div>
              <ToggleButtonGroup
                exclusive
                size="small"
                className={classes.toggleGroup}
                value={editActive}
                onChange={(e, v) => v !== null && setEditActive(v)}
              >
                <ToggleButton value={1}>Aktif</ToggleButton>
                <ToggleButton value={0}>Pasif</ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button sx={lightButtonSx} onClick={closeEdit} disabled={saving}>Vazgeç</Button>
          <Button
            sx={{ ...darkButtonSx, minWidth: 110 }}
            onClick={handleSave}
            disabled={saving || editTop === '' || !editDetail?.trim()}
            startIcon={saving ? <CircularProgress size={14} sx={{ color: ORANGE }} /> : null}
          >
            {isUpdate ? 'Güncelle' : 'Ekle'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* İade ikna anketi onayı */}
      <Dialog open={!!surveyTarget} onClose={() => !saving && setSurveyTarget(null)} fullWidth maxWidth="xs" PaperProps={dialogPaperProps}>
        <DialogTitle className={classes.dialogTitle}>
          İade İkna Anketi
          <IconButton size="small" onClick={() => setSurveyTarget(null)} disabled={saving}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '16px !important' }}>
          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
            <WarningAmberIcon sx={{ color: ORANGE, mt: '2px' }} />
            <Box sx={{ fontSize: '13px', color: DARK }}>
              <b>{surveyTarget?.label}</b> için iade ikna anketi{' '}
              <b style={{ color: surveyTarget?.checked ? '#2e7d32' : '#c62828' }}>{surveyTarget?.checked ? 'aktif' : 'pasif'}</b>{' '}
              yapılacak. Emin misiniz?
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button sx={lightButtonSx} onClick={() => setSurveyTarget(null)} disabled={saving}>Vazgeç</Button>
          <Button
            sx={{ ...darkButtonSx, minWidth: 90 }}
            onClick={confirmSurveyChange}
            disabled={saving}
            startIcon={saving ? <CircularProgress size={14} sx={{ color: ORANGE }} /> : null}
          >
            Evet
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ExchangeTypesDynamic;
